// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"124":"2f19b8dc63c49295","509":"a3cc256d491c6ef4","641":"79e59de782380bd2","682":"497049cc764f447f"}[chunkId] + ".js";
};